import { render, staticRenderFns } from "./sisBreadcrumb.vue?vue&type=template&id=1bd83a54&scoped=true"
import script from "./sisBreadcrumb.vue?vue&type=script&lang=js"
export * from "./sisBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./sisBreadcrumb.vue?vue&type=style&index=0&id=1bd83a54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd83a54",
  null
  
)

export default component.exports